
import {  Button  } from '@material-ui/core';
import classNames from 'classnames';

export const EntryFeeInputRow = ({
    errors,
    register,
    index,
    item,
    handleForm,
    handleChange,
    handleRemove,
    handleAdd,
    values,
    inputFields
}) => {
  return (
    <div className='row mt-2'>
        <div className='col-md-5'>
            {/* Category <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span> */}
            <input 
                type="text" 
                className={classNames("form-control registerEmp__textbox")}
                name={'entryCategory'}
                placeholder={'Category'}
                autoComplete="off"
                defaultValue={handleForm?.entryCategory ? handleForm?.entryCategory : ''}
                onChange={(event) => handleChange(event, index)}
                ref={register}
            />
            {/* <small className="form-text text-danger">{errors.entryCategory && errors.entryCategory.message}</small> */}
        </div>
        <div className='col-md-5'>
            {/* Entry Fees <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span> */}
            <input 
                type="number" 
                className={classNames("form-control registerEmp__textbox")}
                name={'entryFees'}
                placeholder={'Entry Fees'}
                autoComplete="off"
                defaultValue={handleForm?.entryFees ? handleForm?.entryFees : ''}
                onChange={(event) => handleChange(event, index)}
                ref={register}
            />
            {/* <small className="form-text text-danger">{errors.entryFees && errors.entryFees.message}</small> */}
        </div>
        <div className='col-md-1'>
            <div className="addBox">
                {/* <label className="login__textboxLabel jsm__textboxLabel">{} </label> */}
                <Button 
                    onClick={handleAdd}
                    variant="contained" 
                    className="registerEmp__btnLogin jsmAdd">
                    {'Add'}
                </Button>
            </div>
        </div>
        <div className='col-md-1'>
            <div className="removeBox">
                {/* <label className="login__textboxLabel jsm__textboxLabel">{} </label> */}
                <Button 
                    onClick={handleRemove}
                    color="error"
                    variant='outlined'
                    className="registerEmp__btnRemov jsmRemove">
                    {'Remove'}
                </Button>
            </div>
        </div>
    </div>
  )
}
